import { render } from "./BuscarMovimentosFinanceirosModal.vue?vue&type=template&id=48b1f67e&scoped=true&ts=true"
import script from "./BuscarMovimentosFinanceirosModal.vue?vue&type=script&lang=ts"
export * from "./BuscarMovimentosFinanceirosModal.vue?vue&type=script&lang=ts"

import "./BuscarMovimentosFinanceirosModal.vue?vue&type=style&index=0&id=48b1f67e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b1f67e"]])

export default __exports__